export const CREATE_STATEMENT_TEMPLATE_PLACEHOLDER_REQUEST = 'CREATE_STATEMENT_TEMPLATE_PLACEHOLDER_REQUEST';

export const createStatementTemplatePlaceholderRequest = ({ key, content }) => ({
    type: CREATE_STATEMENT_TEMPLATE_PLACEHOLDER_REQUEST,
    payload: {
        key,
        content
    },
});
